import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = ({ data, t }) => {
  const linkedEntity =
    data?.product ||
    data?.store ||
    data?.category ||
    data?.occasion ||
    data?.tag ||
    data?.occasion_type ||
    data?.taxon;

  const basicDetails = [
    {
      label: t("featured_ads.data"),
      name: data?.data ? t(`featured_ads.${data?.data}`) : "-",
    },
    {
      label: t("featured_ads.data_id"),
      name: data?.data_id,
    },
  ];

  if (linkedEntity?.name) {
    basicDetails.push({
      label: t("common.name"),
      name: linkedEntity.name,
    });
  }

  return [
    {
      head: t("common.details"),
      icon: icons?.details,
      details: basicDetails,
    },

    {
      head: t("details.dates"),
      icon: icons?.dates,
      details: [
        {
          label: t("details.created_at"),
          name: dayjs(data?.created_at).format("DD-MM-YYYY HH:mm a"),
        },
        {
          label: t("details.updated_at"),
          name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:mm a"),
        },
      ],
    },
  ];
};
